import React, { createContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "../api/axiosInstance";

export const CustomerContext = createContext();

export const CustomerProvider = ({ children }) => {
  const [customer, setCustomerState] = useState(null);
  const [customerError, setCustomerError] = useState(null);

  const navigate = useNavigate();

  const setCustomer = (customerData) => {
    setCustomerState(customerData);
    if (customerData) {
      localStorage.setItem("customer", JSON.stringify(customerData));
    } else {
      localStorage.removeItem("customer");
    }
  };

  const fetchCustomerInfo = async () => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        navigate("/login");
        return;
      }

      const response = await axios.get("/Customer/CustomerInfo");
      setCustomer(response.data);
       setCustomerError(null);
    }  catch (error) {
    if (error.response?.status === 403) {
      //  مشتری غیرفعال
      setCustomer(null);
      setCustomerError(error.response.data?.message);
    } else if (error.response?.status === 401) {
      navigate("/login");
    } else {
      console.error("❌ خطا در دریافت اطلاعات مشتری:", error);
    }
  }
  };

  useEffect(() => {
    const localCustomer = localStorage.getItem("customer");

    if (localCustomer) {
      setCustomerState(JSON.parse(localCustomer));
    } else {
      fetchCustomerInfo();
    }
  }, []);

  return (
    <CustomerContext.Provider value={{ customer,customerError, setCustomer, fetchCustomerInfo }}>
      {children}
    </CustomerContext.Provider>
  );
};

